module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fc-Ge-Hc 后背.e55b2871.png";